import React from 'react'
import type { FlexProps } from '@vtex/admin-ui'
import { csx, cx } from '@vtex/admin-ui'

export type IndicatorCardContentProps = FlexProps

export const IndicatorCardContent = ({
  className = '',
  ...props
}: IndicatorCardContentProps) => {
  return (
    <div
      className={cx(
        csx({
          display: 'flex',
          flexDirection: 'column',
          gap: '0.3rem',
        }),
        className
      )}
      {...props}
    />
  )
}
